import qs from 'qs';
import client from './client';

const chanceUrl = '/api/v1/project/forecast';
const projectUrl = '/api/v1/project/campaign'; //수주된 프로젝트
const orderUrl = '/api/v1/project/orders';

//매출,매입 견적서 가져오기
//​ api​/v1​/project​/campaign​/document/qte/{saleTypVal}
export const getEstimateFiles = ({ salesType, searchData }) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${projectUrl}/document/qte/${salesType}?${queryString}`);
};

//매출 발주서, 매입 발주서
export const getOrderSheetFiles = ({ salesType, searchData }) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${projectUrl}/document/files/${salesType}?${queryString}`);
};

//프로젝트  리스트
export const getProjects = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${projectUrl}/nml/list?${queryString}`);
};

//유지보수 프로젝트 리스트 프로젝트
export const getMainProjects = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${projectUrl}/mtm/list?${queryString}`);
};

//계약 관리(프로젝트+유지보수 통합) 리스트. nml/mtm list와 서버 로직이 같지만 prjTyp를
//강제로 세팅하지 않아서, searchData.prjTyp 를 'N'/'M'으로 넘기면 해당 유형만, 비우면
//(ForcastMapper.xml의 <if test="prjTyp != ''">) 전체가 나온다 - 그래서 이 화면은 백엔드를
//건드리지 않고 기존 /list 엔드포인트만 재사용한다.
export const getContracts = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${projectUrl}/list?${queryString}`);
};

//수주된 프로젝트 가져오기
export const getProject = (id) => client.get(`${chanceUrl}/info/${id}`);

//프로젝트의 활성화된 수주 확인
export const getProjectOrderCount = (id) =>
  client.get(`${orderUrl}/list/${id}/count`);

//수주품의서 히스토리
export const getProjectOrderHistory = (id) => {
  return client.get(`${orderUrl}/list/${id}`);
};

//프로젝트 수주품의서
export const getOrderInfoAll = (id) => {
  return client.get(`${orderUrl}/data/${id}`);
};

//초기 매입,매출 내역 리스트
export const getInitPayments = (id) => {
  return client.get(`${orderUrl}/base/${id}`);
};

//수주품의서 저장
export const addReceiveOrder = (dataToSubmit) => {
  //console.log(JSON.stringify(dataToSubmit),'addReceiveOrder');
  return client.post(`${orderUrl}/data`, dataToSubmit);
};

export const editReceiveOrder = (id, dataToSubmit) => {
  // console.log(JSON.stringify(dataToSubmit), 'addReceiveOrder');
  return client.put(`${orderUrl}/data/${id}`, dataToSubmit);
};

export const approveReceiveOrderApprovalV2 = (roUuid, data) => {
  return client.post(`${orderUrl}/data/${roUuid}/approval-v2/approve`, data);
};

export const rejectReceiveOrderApprovalV2 = (roUuid, data) => {
  return client.post(`${orderUrl}/data/${roUuid}/approval-v2/reject`, data);
};

export const recallReceiveOrderApprovalV2 = (roUuid) => {
  return client.post(`${orderUrl}/data/${roUuid}/approval-v2/recall`);
};

//영업통계CEO
export const getProjectListReport = (searchData, checkedList) => {
  const queryString = qs.stringify(searchData);
  let url = `${chanceUrl}/list/report?${queryString}`;

  if (checkedList !== null && checkedList.length > 0) {
    url = url + `&prjImpts=${checkedList}`;
  }
  return client.get(url);
};

//프로젝트별 summary
export const getProjectsSummary = (searchData) => {
  const queryString = qs.stringify(searchData);
  let url = `${chanceUrl}/list/summary/year?${queryString}`;
  return client.get(url);
};

export const getProjectsMonthSummary = (searchData) => {
  const queryString = qs.stringify(searchData);
  let url = `${chanceUrl}/list/summary/month?${queryString}`;
  return client.get(url);
};

export const getProjectsDeptStatics = (year) => {
  let url = `${chanceUrl}/list/summary/account/${year}/N`;
  return client.get(url);
};

export const getMaintanceDeptStatics = (year) => {
  let url = `${chanceUrl}/list/summary/account/${year}/M`;
  return client.get(url);
};

export const getProjectsDeptStaticsBySearchRange = (searchRange) => {
  const queryString = qs.stringify(searchRange);
  let url = `${chanceUrl}/list/summary/account/N?${queryString}`;
  return client.get(url);
};

export const getMaintanceDeptStaticsBySearchRange = (searchRange) => {
  const queryString = qs.stringify(searchRange);
  let url = `${chanceUrl}/list/summary/account/M?${queryString}`;
  return client.get(url);
};

export const getProjectsDeptCountStaticsBySearchRange = (searchRange) => {
  const queryString = qs.stringify(searchRange);
  let url = `${chanceUrl}/list/summary/count?${queryString}`;
  return client.get(url);
};

export const getProjectsDeptCountStatics = (year) => {
  let url = `${chanceUrl}/list/summary/count/${year}`;
  return client.get(url);
};

export const getProjectsDeptSalesStatics = (year) => {
  let url = `${chanceUrl}/list/summary/sales/${year}`;
  return client.get(url);
};

const orderSheets = '/api/v1/project/spo';

export const getBuysOrderSheet = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${orderSheets}/list?${queryString}`);
};

//보낸 발주서 가져오기
export const getOrderSheets = (prjUuid) => {
  return client.get(`${orderSheets}/list/${prjUuid}`);
};

export const downloadOrderSheet = (prjUuid, spoUuid) => {
  return client.get(`${orderSheets}/info/${prjUuid}/${spoUuid}/print`, {
    responseType: 'arraybuffer',
  });
};

export const addOrderSheet = (dataToSubmit) => {
  return client.post(
    `${orderSheets}/info/${dataToSubmit.prjUuid}`,
    dataToSubmit,
  );
};

export const editOrderSheet = (dataToSubmit) => {
  return client.put(
    `${orderSheets}/info/${dataToSubmit.prjUuid}/${dataToSubmit.spoUuid}`,
    dataToSubmit,
  );
};

export const removeOrderSheet = (prjUuid, spoUuid) => {
  return client.delete(`${orderSheets}/info/${prjUuid}/${spoUuid}`);
};

export const downloadOrderSheetPdf = (prjUuid, spoUuid) => {
  return client.get(`${orderSheets}/info/${prjUuid}/${spoUuid}/pdf`, {
    responseType: 'arraybuffer',
  });
};

export const initTaxbills = (prjUuid, searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${orderUrl}/pb/${prjUuid}/create?${queryString}`);
};

// 수주품의서 리스트
export const getProjectOrders = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${orderUrl}/data/list?${queryString}`);
};

//프로젝ㅌ/유지보수 복사
export const copyProject = (id) => client.get(`${projectUrl}/copy/${id}`);
